import { render, staticRenderFns } from "./DashboardRegister.vue?vue&type=template&id=4f986e85&"
import script from "./DashboardRegister.vue?vue&type=script&lang=js&"
export * from "./DashboardRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports